import { EMPTY_VALUE } from './strings';

// this function takes a string or float and returns it as with 4 decimal places
export const convertToFourDecimalPlaces = (value?: string | number): string => {
  if (value === undefined || value === null) return EMPTY_VALUE;

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) return EMPTY_VALUE;

  return num.toFixed(4); // Format to 4 decimal places
};
